import { render, staticRenderFns } from "./contact-acquisition-details.vue?vue&type=template&id=17429df8&scoped=true&"
import script from "./contact-acquisition-details.vue?vue&type=script&lang=js&"
export * from "./contact-acquisition-details.vue?vue&type=script&lang=js&"
import style0 from "./contact-acquisition-details.vue?vue&type=style&index=0&id=17429df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17429df8",
  null
  
)

export default component.exports